<template>
  <div class="m-view-all">
    <router-link
      class="m-view-all-btn x-link-active"
      :to="url"
    >
      <span
        >All Event{{ isLive ? '(s)' : 's' }} <template v-if="count > 0">{{ count }}</template>
      </span>
      <svg
        class="icon-arrow"
        width="12"
        height="12"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M307.2 153.6c12.8-25.6 64-25.6 89.6 0L755.2 512c25.6 25.6 25.6 64 0 89.6-25.6 25.6-64 25.6-89.6 0L307.2 243.2c-25.6-25.6-25.6-64 0-89.6z" />
        <path d="M755.2 512c25.6 25.6 25.6 64 0 89.6L396.8 972.8c-25.6 25.6-64 25.6-89.6 0-25.6-25.6-25.6-64 0-89.6L665.6 512c25.6-25.6 64-25.6 89.6 0z" />
      </svg>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ViewAll',
  props: {
    url: {
      type: [String, Object],
      required: true
    },
    isLive: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.m-view-all {
  display: flex;
  justify-content: center;
  border-radius: 0 0 20px 20px;
  background-image: linear-gradient(180deg, #000 0%, #161616 50%);
  color: #999;
  font-size: 14px;
}

.m-view-all-btn {
  height: 50px;
  padding: 0 8px;
  color: #999;
  line-height: 50px;

  .icon-arrow {
    margin-top: -3px;
    fill: #999;
    vertical-align: middle;
  }
}

[data-mode='light'] {
  .m-view-all {
    background-image: linear-gradient(180deg, rgba(255, 255, 255, 0%) 0%, #fff 100%);
  }
}
</style>
